export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12900.b988bb50.jpg";